import bgImage from "../assets/resturant-scaled.jpg";

const OpeningHours = () => {
  return (
    <section className="relative w-full min-h-[100vh] flex items-center justify-center overflow-hidden py-24">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "130% cover",
          backgroundPosition: "top top",
          filter: "grayscale(100%)",
        }}
      />
      <div className="hero-overlay absolute inset-0" />
      <div className="relative z-10 flex flex-col md:flex-row items-center gap-12 md:gap-20 px-6 md:px-16 max-w-6xl mx-auto w-full justify-end">
        <div className="text-center md:text-center">
          <h2 className="font-heading text-2xl md:text-3xl tracking-wide text-foreground uppercase mb-10 leading-[1.15]">
            Öppettider
          </h2>
          <div className="text-center space-y-8">
            <div>
              <h3 className="font-heading text-sm tracking-wide text-primary uppercase mb-1.5 leading-[1.2]">
                Lunch Menu
              </h3>
              <p className="font-body text-sm text-muted-foreground">
                Tisdag - Fredag 11:30 - 14:00
              </p>
            </div>
            <div>
              <h3 className="font-heading text-sm tracking-wide text-primary uppercase mb-1.5 leading-[1.2]">
                Kväll Menu
              </h3>
              <p className="font-body text-sm text-muted-foreground">
                Tisdag till Söndag 14:00 - Sent
              </p>
            </div>
            <div>
              <h3 className="font-heading text-sm tracking-wide text-primary uppercase mb-1.5 leading-[1.2]">
                Breakfast
              </h3>
              <p className="font-body text-sm text-muted-foreground">
                Lördag & Söndag: 09:00-14:00
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;
